/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import _ from 'lodash';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import List from '@material-ui/core/List';
import MuiListSubheader from '@material-ui/core/ListSubheader';
import InputAdornment from '@material-ui/core/InputAdornment';
import { FormControlLabel, Radio, RadioGroup, SvgIcon } from '@material-ui/core';
import { connect } from 'react-redux';
import {
  handleAddFees,
  handleChangeFees,
  handleChangeFeesValue,
  handleRemoveFees,
  handleChangeMinimum,
  handleNewCity,
  handleSelectSuggest,
  handleInputChange,
  handleDeliveryZone,
  updateDeliveryZoneShape,
  handleClose
} from './DeliveryZoneModal.service';
import { styles } from './DeliveryZoneModal.styles';
import { mainColor, UNIT, FIRST_LEVEL } from '../../constants';
import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import Input from '../Input';
import Paper from '../Paper';
import Modal from '../Modal';
import IconButton from '../IconButton';
import * as actions from '../../actions/index';
import { isDeliveryPriceInKm } from '../../utils/delivery';
import { ReactComponent as cercle } from '../../assets/pictures/cercle.svg';
import { ReactComponent as square } from '../../assets/pictures/square.svg';
import AddressSearchAutocompleteInput from '../AddressSearchAutocompleteInput/AddressSearchAutocompleteInput.view';

const CustomSvgIcon = withStyles(() => ({
  root: {
    width: UNIT * 2,
    height: UNIT * 2
  }
}))(SvgIcon);

const ListSubHeaderFees = withStyles({
  gutters: {
    paddingLeft: UNIT * 0.625
  }
})(MuiListSubheader);
const INITIAL_STATE = {
  search: '',
  valueGeolocApi: '',
  deliveryZone: {
    cityName: '',
    districtName: '',
    minimum: 0,
    servicePrice: {},
    typeZone: false,
    shape: 'circle'
  },
  index: 0
};
class DeliveryZoneModal extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    this.setState({
      deliveryZone: this.props.deliveryZone
    });
  }

  renderConfigfees = () => {
    const { classes, addCityModal, isMap } = this.props;
    const { deliveryZone } = this.state;
    const { minimum = 0, servicePrice = {}, shape = 'circle' } = deliveryZone;
    return (
      <Paper className={classes.paperStyle}>
        {!isDeliveryPriceInKm() && (
          <List
            subheader={
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <ListSubHeaderFees className={classes.headerFee}>
                  Frais de livraison
                </ListSubHeaderFees>
                <div style={{ display: 'flex' }}>
                  <IconButton
                    label='Add'
                    title='Ajouter un frais de livraison'
                    className={classes.iconStyle}
                    onClick={() => handleAddFees(this)}
                  >
                    <AddIcon style={{ fontSize: UNIT }} />
                  </IconButton>
                </div>
              </div>
            }
            className={classes.rootFees}
          >
            {_.keys(servicePrice).map((pallier, i) => (
              <div className={classes.form} key={i.toString()}>
                <div className={classes.formControl}>
                  <p>{i === 0 ? 'Panier à partir de' : ''}</p>
                  <Input
                    id={pallier}
                    type='number'
                    value={
                      servicePrice[pallier].priceOrder < 0 ? 0 : servicePrice[pallier].priceOrder
                    }
                    onChange={event => handleChangeFees(event, this)}
                    InputProps={{
                      endAdornment: <InputAdornment position='end'>€</InputAdornment>
                    }}
                  />
                </div>
                <div className='d-flex flex-column px-2'>
                  <p>{i === 0 ? 'Frais' : ''}</p>
                  <Input
                    id={pallier}
                    type='number'
                    value={servicePrice[pallier].fees < 0 ? 0 : servicePrice[pallier].fees}
                    onChange={event => handleChangeFeesValue(event, this)}
                    InputProps={{
                      endAdornment: <InputAdornment position='end'>€</InputAdornment>
                    }}
                  />
                </div>
                <div style={{ display: 'flex' }}>
                  <IconButton
                    label='Remove'
                    title='Supprimer le frais'
                    className={classes.icon}
                    onClick={() => handleRemoveFees(pallier, this)}
                    style={{ alignSelf: 'flex-end' }}
                  >
                    <DeleteOutlinedIcon className={classes.removeIcon} />
                  </IconButton>
                </div>
              </div>
            ))}
          </List>
        )}

        <div
          className={`d-flex  ${isDeliveryPriceInKm() ? 'flex-column my-2' : 'align-items-center mt-2'
            }`}
        >
          <div className={classes.form2}>
            <p className={classes.cancelItem}>Minimum d'achat:</p>
          </div>

          <div className='d-flex flex-column px-2'>
            <Input
              id='minimum'
              type='number'
              value={minimum < 0 ? 0 : minimum}
              onChange={event => handleChangeMinimum(event, this)}
              InputProps={{
                endAdornment: <InputAdornment position='end'>€</InputAdornment>
              }}
            />
          </div>
        </div>
        {isMap && addCityModal && (
          <div className='d-flex align-items-center mt-2'>
            <div className={classes.form2}>
              <p className={classes.cancelItem}>Forme de la zone:</p>
            </div>

            <RadioGroup
              aria-label='shape'
              name='shape'
              id='shape'
              value={shape}
              onChange={e => updateDeliveryZoneShape(e, this)}
            >
              <div className='d-flex align-items-center'>
                <CustomSvgIcon
                  viewBox='0 0 512 512'
                  component={cercle}
                  htmlColor={`${mainColor.hexa}69`}
                />
                <FormControlLabel
                  style={{
                    margin: 0
                  }}
                  value='circle'
                  control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />}
                  label='Cercle'
                />
              </div>
              <div className='d-flex justify-content-center align-items-center'>
                <CustomSvgIcon
                  viewBox='0 0 512 512'
                  component={square}
                  htmlColor={`${mainColor.hexa}69`}
                />
                <FormControlLabel
                  style={{
                    margin: 0
                  }}
                  value='polygon'
                  control={<Radio classes={{ root: classes.radio, checked: classes.checked }} />}
                  label='Polygone'
                />
              </div>
            </RadioGroup>
          </div>
        )}
      </Paper>
    );
  };

  render() {
    const { isMap, isOpen, addCityModal, zoneLevel } = this.props;
    const { isFilledAddressValid, valueGeolocApi, deliveryZone } = this.state;
    const { typeZone, cityName, districtName, priority } = deliveryZone;
    return (
      <Modal
        isOpen={isOpen}
        color='secondary'
        title={
          addCityModal
            ? 'Nouvelle zone de livraison'
            : `Modifier la zone de livraison${isMap
              ? ` n° ${priority}`
              : `: ${zoneLevel === FIRST_LEVEL ? cityName : districtName}`
            }`
        }
        header
        size='lg'
        modalBodyStyle={{ backgroundColor: 'rgba(200, 200, 200, 0.3)' }}
        handleClose={() => handleClose(this)}
        showCancelBtn
        onClick={() => (isMap ? handleDeliveryZone(this) : handleNewCity(this))}
        fixed
        btnTxt='Enregistrer'
      >
        <div style={{ height: `${addCityModal && !typeZone && !isMap ? '280px' : ''}` }}>
          {addCityModal && !isMap ? (
            <AddressSearchAutocompleteInput
              typedAddress={valueGeolocApi}
              setTypedAddress={typedAddress => handleInputChange(typedAddress, this)}
              handleAddressSelection={(_, placeId) => handleSelectSuggest(placeId, this)}
              handleAddressInputFormControlError={(status, clearSuggestions) => null}
              hasErrorAddressMessage={false}
              inputElementRef={null}
              animatePlaceholder={null}
              isFilledAddressValid={isFilledAddressValid}
              label={zoneLevel === FIRST_LEVEL ? 'Ajouter une ville' : 'Ajouter un quartier'}
              autoFocus
              minCharToFetch={3}
              paddingRight={'40px'}
            />
          ) : null}

          {typeZone || !addCityModal || isMap ? (
            <div className={typeZone && 'mt-4'}>{this.renderConfigfees()}</div>
          ) : null}
        </div>
      </Modal>
    );
  }
}

function mapStateToProps({ firebaseRealTime }) {
  const { shop } = firebaseRealTime;

  return {
    configurations: shop
  };
}
DeliveryZoneModal.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(DeliveryZoneModal));
